<template>
    <v-card>
        <v-card-title class="justify-center">Vector store: {{ store.name }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row class="pa-2 ma-0">
                <v-col cols=3 class="py-0 px-2">Store id        </v-col><v-col cols=9 class="py-0 px-2">{{ store.id }}</v-col>
                <v-col cols=3 class="py-0 px-2">Store status    </v-col><v-col cols=9 class="py-0 px-2">{{ store.status }}</v-col>
                <v-col cols=3 class="py-0 px-2">Created at      </v-col><v-col cols=9 class="py-0 px-2">{{ store.created_date }}</v-col>
                <v-col cols=3 class="py-0 px-2">Last active at  </v-col><v-col cols=9 class="py-0 px-2">{{ store.last_active_date }}</v-col>
                <v-col cols=3 class="py-0 px-2">Expires         </v-col><v-col cols=9 class="py-0 px-2">{{ store.expires }}</v-col>
                <v-col cols=3 class="py-0 px-2">Files total     </v-col><v-col cols=9 class="py-0 px-2">{{ store.file_counts.total }}</v-col>
                <v-col cols=3 class="py-0 px-2"> - completed    </v-col><v-col cols=9 class="py-0 px-2">{{ store.file_counts.completed }}</v-col>
                <v-col cols=3 class="py-0 px-2"> - in progress  </v-col><v-col cols=9 class="py-0 px-2">{{ store.file_counts.in_progress }}</v-col>
                <v-col cols=3 class="py-0 px-2"> - failed       </v-col><v-col cols=9 class="py-0 px-2">{{ store.file_counts.failed }}</v-col>
                <v-col cols=3 class="py-0 px-2"> - cancelled    </v-col><v-col cols=9 class="py-0 px-2">{{ store.file_counts.cancelled }}</v-col>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small :disabled="disableAll!==0" @click="addFiles">Add files</v-btn>
            <v-btn color="error" small :disabled="disableAll!==0" @click="removeFiles">Remove files</v-btn>
            <v-btn color="error" small :disabled="disableAll!==0" @click="removeStore">Delete store</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

    export default {
        components: {
        },
        props: {
            store: {
                required: true,
            }
        },
        data() {
            return {
                disableAll: 0,
            }
        },
        methods: { 
            addFiles() {
                this.disableAll += 1;
                if (this.store.name === "villa_for_you") {
                    this.$axios.post("ares/json/ares/syst/openai/createGeneralVectorStoreFiles.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "createGeneralVectorStoreFiles",
                        },
                        createGeneralVectorStoreFiles: this.store,
                    }).then((res) => {
                        if (res.data.error) {
                            // console.log(res.data.error);
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: res.data.error.message,
                                color: "error",
                            });
                            this.disableAll -= 1;
                        } else {
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: res.data.createGeneralVectorStoreFiles.text,
                                color: res.data.createGeneralVectorStoreFiles.color,
                            });
                            this.disableAll -= 1;
                            this.$emit("updateData", "refresh");
                        }
                    });
                } else {
                    console.log(this.store);
                    this.$axios.post("ares/json/ares/syst/openai/createVectorStoreFiles.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "createVectorStoreFiles",
                        },
                        createVectorStoreFiles: this.store,
                    }).then((res) => {
                        if (res.data.error) {
                            // console.log(res.data.error);
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: res.data.error.message,
                                color: "error",
                            });
                            this.disableAll -= 1;
                        } else {
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: res.data.createVectorStoreFiles.text,
                                color: res.data.createVectorStoreFiles.color,
                            });
                            this.disableAll -= 1;
                            this.$emit("updateData", "refresh");
                        }
                    });
                }
            },  
            removeFiles() {
                this.disableAll += 1;
                this.$axios.post("ares/json/ares/syst/openai/deleteVectorStoreFiles.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "deleteVectorStoreFiles",
                    },
                    deleteVectorStoreFiles: this.store,
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                        this.disableAll -= 1;
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.deleteVectorStoreFiles.text,
                            color: res.data.deleteVectorStoreFiles.color,
                        });
                        this.disableAll -= 1;
                        this.$emit("updateData", "refresh");
                    }
                });
            },  
            removeStore() {
                this.disableAll += 1;
                this.$axios.post("ares/json/ares/syst/openai/deleteVectorStores.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "deleteVectorStores",
                    },
                    deleteVectorStores: [this.store],
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                        this.disableAll -= 1;
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.deleteVectorStores.text,
                            color: res.data.deleteVectorStores.color,
                        });
                        this.disableAll -= 1;
                        this.$emit("updateData", "refresh");
                    }
                });
            },  
        }
    }
</script>
